export const APP_STORE_URL =
  "https://apps.apple.com/us/app/morph-inspect/id6737966284";
export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.morph_technologies.inspectionapp&hl=en_US";
